<div class="pdf-area">
    <!-- <ngx-extended-pdf-viewer
    [base64Src]="base64Src"
    [zoom]="'page-width'"
    [height]="'auto'"
    [(page)]="page"
    [(pageLabel)]="pageLabel"
    [textLayer]="true"
    (pageRendered)="onPageRendered()">
    </ngx-extended-pdf-viewer> -->
    <!-- <iframe
    type="application/pdf"
    [src]="fileUrl"
    (load)="onDocumentLoad()"
    (error)="onFileError()"
    ></iframe> -->
    <ng-container *ngIf="documentLoad">
            
        <dk-doc-viewer-manager
        [url]="fileUrl"
       [documentLoad]="documentLoad"
      [docId]="docId"
      [width]="800"   
      [height]="1000"
      ></dk-doc-viewer-manager> 
  </ng-container>
</div>